import { useState } from 'react';

import { Overlay } from '@american-autonomy/ag-ui';

import useTranslation from './hooks/useTranslation';

import DroneComponentsTab from './components/DroneComponentsTab';
import DroneDetailsDrawerHeader from './components/DroneDetailsDrawerHeader';
import DroneDetailsDrawerTabs from './components/DroneDetailsDrawerTabs';
import DroneHealthTab from './components/DroneHealthTab';
import DroneServiceLogTab from './components/DroneServiceLogTab';
import {
    COMPONENTS_TAB_KEY,
    DEFAULT_TAB_INDEX,
    HEALTH_TAB_KEY,
    SERVICE_LOG_TAB_KEY,
    TEST_ID
} from './constants';
import type { FunctionComponent, HandlePanelClick, Props } from './types';

import styles from './styles.module.scss';

const DroneDetailsDrawer: FunctionComponent<Props> = ({
    className = '',
    drone,
    onClose,
    onServiceSaved,
    testId = TEST_ID
}) => {
    const { tabs } = useTranslation();
    const [activeTabIndex, setActiveTabIndex] = useState(DEFAULT_TAB_INDEX);

    const handlePanelClick: HandlePanelClick = event => event.stopPropagation();

    const activeTabKey = tabs[activeTabIndex]?.key;

    const tabContent =
        activeTabKey === HEALTH_TAB_KEY ? (
            <DroneHealthTab className={styles.content} drone={drone} />
        ) : activeTabKey === COMPONENTS_TAB_KEY ? (
            <DroneComponentsTab className={styles.content} drone={drone} />
        ) : activeTabKey === SERVICE_LOG_TAB_KEY ? (
            <DroneServiceLogTab
                className={styles.content}
                drone={drone}
                onServiceSaved={onServiceSaved}
            />
        ) : null;

    return (
        <Overlay onClose={onClose} testId={testId}>
            <aside
                className={`${className} ${styles.droneDetailsDrawer}`}
                onClick={handlePanelClick}>
                <DroneDetailsDrawerHeader
                    name={drone.name}
                    onClose={onClose}
                    serial={drone.flightControllerSerialNumber}
                />

                <DroneDetailsDrawerTabs
                    activeIndex={activeTabIndex}
                    onSelect={setActiveTabIndex}
                    tabs={tabs}
                />

                {tabContent}
            </aside>
        </Overlay>
    );
};

export default DroneDetailsDrawer;
